__turbopack_context__.v({
  "card": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__card",
  "cardInner": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__cardInner",
  "fade-in": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__fade-in",
  "flushBottom": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__flushBottom",
  "flushTop": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__flushTop",
  "image": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__image",
  "imageRight": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__imageRight",
  "root": "BlockTwoColumnGrid-module-scss-module__u_pZ5G__root",
});
